import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LinkedIn from '../../images/icons/fontawesome-linkedin-square.svg';
import Twitter from '../../images/icons/fontawesome-twitter-square.svg';
import QuickSearch from './QuickSearch';

const ContactUs = () => (
  <Fragment>
    <div className="slge-contact-us">
      <a
        className="pt-1"
        target="_blank"
        rel="noreferrer noopener"
        href="https://twitter.com/MSQInstitute"
        aria-label="Twitter account for the Center for State and Local Government Excellence"
      >
        <img src={Twitter} className="social-icon grow mx-2 has-text-white" />
      </a>
      <a
        className="pt-1"
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.linkedin.com/company/center-for-state-and-local-government-excellence"
      >
        <img src={LinkedIn} className="social-icon grow mr-2 has-text-white" />
      </a>

      <QuickSearch />
    </div>
  </Fragment>
);

ContactUs.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default ContactUs;
